import { BenefitDTOBenefitEnum } from 'probonio-shared-ui/api';
import { useMemo } from 'react';
import { useActiveBenefitsQuery } from '../bikeleasing/useActiveBenefitsQuery';

interface AccessibleBenefitsResult {
  accessibleBenefits: Set<BenefitDTOBenefitEnum>;
  isLoading: boolean;
}

// Keeps access to residual benefits: unredeemed coupons and the balance on an active card.

export const useAccessibleBenefits = (): AccessibleBenefitsResult => {
  const { data: benefitsData, isLoading: isBenefitsLoading } = useActiveBenefitsQuery();

  const accessibleBenefits = useMemo(() => {
    const set = new Set<BenefitDTOBenefitEnum>();

    if (benefitsData) {
      benefitsData.benefits.forEach(b => set.add(b.benefit));
    }

    if (benefitsData?.benefits.some(b => b.benefit === BenefitDTOBenefitEnum.Gifts)) {
      set.add(BenefitDTOBenefitEnum.Coupons);
    }

    return set;
  }, [benefitsData]);

  return {
    accessibleBenefits,
    isLoading: isBenefitsLoading,
  };
};
